import { render, staticRenderFns } from "./AttachmentIcon.vue?vue&type=template&id=812a9c1e"
import script from "./AttachmentIcon.vue?vue&type=script&lang=ts"
export * from "./AttachmentIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports